import { useAbility } from "@amazing-care/auth";
import { useEffect } from "react";
import { PAGES } from "@/route-modules";

/**
 * Downloads the code for every page this user can open once the browser is
 * idle, so a click never waits on a chunk. Data is already warm in the query
 * cache, which leaves the chunk as the only thing a first visit would fetch.
 */
export function usePreloadPages() {
  const ability = useAbility();
  const canManageUsers = ability.can("manage", "Manager");
  const canManageContent = ability.can("manage", "Announcement");

  useEffect(() => {
    const pages = [PAGES.staffHome, PAGES.department, PAGES.document, PAGES.activity];
    if (canManageUsers) pages.push(PAGES.adminUsers);
    if (canManageContent) pages.push(PAGES.adminContent);

    function preload() {
      for (const load of pages) {
        // A failed preload is harmless: navigating loads the page again.
        load().catch(() => undefined);
      }
    }

    // Safari has no requestIdleCallback.
    if ("requestIdleCallback" in window) {
      const handle = window.requestIdleCallback(preload, { timeout: 3000 });
      return () => window.cancelIdleCallback(handle);
    }
    const timer = setTimeout(preload, 1500);
    return () => clearTimeout(timer);
  }, [canManageUsers, canManageContent]);
}
